<template>
  <div class="profile-block profile-userpic">
    <avatar class="profile-userpic__photo"
            :upic="upic"
            :name="name"
            :size="size">
    </avatar>
    <div v-if="isMyProfile || admin" class="profile-userpic__button">
      <router-link class="el-button el-button--default" :to="{ name: isMyProfile && !admin ? 'profileEdit' : 'userEdit', params: { id: user.getId() } }">
        <i class="el-icon-edit"></i>
        <span>{{ $t('common.dropdown_menu.edit_profile') }}</span>
      </router-link>
    </div>
  </div>
</template>
<script>
  import avatar from 'src/components/Avatar/avatar.vue'
  import {USER_ROLE_ADMIN} from '@/constants'

  export default {
    props: {
      user: {
        type: Object,
        default: () => {}
      },
      upic: String,
      name: String,
      size: String,
      editLink: String,
      perms: {
        type: Object,
        default: () => {}
      },
      isMyProfile: Boolean
    },
    components: {
      avatar
    },
    computed: {
      admin () {
        if (this.$store.state.user.user) {
          return this.$store.state.user.user.checkRole(USER_ROLE_ADMIN)
        }
        return false
      }
    }
  }
</script>
<style lang="scss">
@import 'src/assets/sass/paper/variables';

.profile-userpic {
  text-align: center;
  padding-top: 25px;

  &__button {
    margin: 25px -15px 0 -15px;
    .el-button {
      max-width: 100%;
      border-color: #e5e5e5;
      color: $secondary-font-color;

      &:hover {
        color: #409eff;
        border-color: #c6e2ff;
        background-color: #ecf5ff;
      }
    }
  }
}
</style>